import angular from 'angular';
import { MeurhBureausEquipesMembrosController } from './bureaus-equipes-membros.controller';

export class MeurhBureausEquipesMembrosComponent implements angular.IComponentOptions {
    static selector = 'meurhBureausEquipesMembros';
    static controller = MeurhBureausEquipesMembrosController;
    static template = require('!!html-loader!./bureaus-equipes-membros.html');
    static bindings = {
        administradorBureaus: '<',
        tenantsLimite: '<',
        recarga: '<',
        aoSemPermissao: '&',
    };
}
